import { render, staticRenderFns } from "./PunctualityReportTable.vue?vue&type=template&id=74e875ee"
import script from "./PunctualityReportTable.vue?vue&type=script&lang=js"
export * from "./PunctualityReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports